import {
  FileContentType,
  FileType,
  IFileRefGetBaseName,
  IFileRefGetCleanPath,
  IFileReference,
  IFileRefIsLocal
} from '@summit/core';
import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Dispute } from './dispute';

export class DisputeFile extends EboObjectTO implements IFileReference {
  disputeId: string;
  dispute: Dispute;
  name: string;
  path: string;
  thumbNail: string;
  fileType: FileType;
  contentType: FileContentType;
  blobPath: string;
  order: number;

  constructor(jsonData?: Partial<DisputeFile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.dispute) this.dispute = new Dispute(jsonData.dispute);
    }
    this.contentType ??= FileContentType.Attachment;
  }
  get baseName(): string {
    return IFileRefGetBaseName(this);
  }
  get cleanPath(): string {
    return IFileRefGetCleanPath(this);
  }
  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
